import React, { FC, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import { useIntl } from 'react-intl';
import { Breadcrumb } from 'antd';
import { pathToRegexp } from 'path-to-regexp';
import { queryAncestors } from '@app/utils';
import iconMap from '@app/utils/iconMap';
import './Bread.less';

interface BreadPropsInterface {
  routeList: any[];
}

export const Bread: FC<BreadPropsInterface> = ({ routeList }) => {
  const location = useLocation();
  // const { formatMessage } = useIntl();

  const generateBreadcrumbs = paths => {
    return paths.map((item, key) => {
      const content = item && (
        <Fragment>
          {item.icon && <span style={{ marginRight: 4 }}>{iconMap[item.icon]}</span>}
          {item.name}
        </Fragment>
      );

      return (
        item && (
          <Breadcrumb.Item key={key}>
            {paths.length - 1 !== key ? <Link to={item.route || '#'}>{content}</Link> : content}
          </Breadcrumb.Item>
        )
      );
    });
  };

  // Find a route that matches the pathname.
  const currentRoute = routeList.find(_ => _.route && pathToRegexp(_.route).exec(location.pathname));

  // Find the breadcrumb navigation of the current route match and all its ancestors.
  const paths = currentRoute ? queryAncestors(routeList, currentRoute, 'breadcrumbParentId').reverse() : [routeList[0]];

  return <Breadcrumb className="bread">{generateBreadcrumbs(paths)}</Breadcrumb>;
};
